import { EventHandler, IEventBusTransport } from './types';

export class EventBus {
	private static transport: IEventBusTransport | null = null;
	private static handlers = new Map<string, Set<EventHandler<any>>>();

	public static add<T = unknown>(
		eventName: string,
		callback: EventHandler<T>,
	): () => void {
		let set = this.handlers.get(eventName);
		if (!set) {
			this.handlers.set(eventName, (set = new Set()));
		}

		set.add(callback);

		return () => set!.delete(callback);
	}

	public static remove<T = unknown>(
		eventName: string,
		callback: EventHandler<T>,
	): void {
		this.handlers.get(eventName)?.delete(callback);
	}

	public static trigger(eventName: string, payload?: unknown): void {
		const set = this.handlers.get(eventName);
		if (!set) {
			return;
		}

		[...set].forEach((cb) => {
			try {
				cb(payload);
			} catch (e) {
				console.error('[EventBus] handler threw', e);
			}
		});
	}

	/**
	 * Вызвать событие на стороне сервера
	 * @param eventName
	 * @param payload
	 */
	public static triggerServer(eventName: string, payload?: unknown): void {
		if (!this.transport) {
			throw new Error('EventBus transport is not set');
		}

		this.transport.sendToServer(eventName, payload);
	}

	/**
	 * Вызвать событие на стороне клиента
	 * @param eventName
	 * @param payload
	 */
	public static triggerClient(eventName: string, payload?: unknown): void {
		if (!this.transport) {
			throw new Error('EventBus transport is not set');
		}

		this.transport.sendToClient(eventName, payload);
	}

	/**
	 * Установить транспорт для EventBus
	 * @param transport
	 */
	public static setTransport(transport: IEventBusTransport) {
		this.transport = transport;
	}
}
